import React from 'react';
import { inject, observer } from 'mobx-react';
import H5PostImgList from './h5';
import PCPostImgList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface ThreadImgListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    cover?: any;
    imageList: any;
    maxDisplay?: number;
    onImageClick?: any;
    isVideo?: any
    videoData?: any
}

@inject('app', 'site', 'user')
@observer
// 下载APP入口，h5是悬浮在页面顶部，pc是放在页面内容右侧
class ThreadImgList extends React.Component<ThreadImgListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('这是header');
    }

    render() {
        const { site, app, imageList, ...props } = this.props;
        const platform = app?.platform || 'h5';
        
        if (platform === 'pc') {
            return <PCPostImgList imageList={imageList} {...props} />;
        }
        
        return <H5PostImgList imageList={imageList} {...props} />;

    }
}

export default ThreadImgList;